const KEY = 'mp_session_token';

export function getSessionToken(): string {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export function setSessionToken(token: string | null | undefined) {
  try {
    if (!token) sessionStorage.removeItem(KEY);
    else sessionStorage.setItem(KEY, token);
  } catch {
    /* private mode */
  }
}
